import React from "react"
import styled, { css } from 'styled-components'
import { Container } from "../styles/Container"
import { breakpoint } from "../layout/styles"
import Image from "next/image"
import ReactHtmlParser from 'react-html-parser'
import Link from "next/link"
import Button from "../layout/Button"

/**
 * PageTiles Component: Displays a list of tiles (with images, headings, and links) 
 * based on the provided data.
 * 
 * @param {object} data - Data object containing section heading, body, and tiles.
 */
const PageTiles = ({ data }) => {
  return (
    <Wrapper>
      {data.section_heading && <h2>
        {data.section_heading}
      </h2>}
      {data.section_body && <Body>
        {ReactHtmlParser(data.section_body)}
      </Body>}
      <Items>
        {data?.tiles.map((tile) => {
          return <Item key={tile._metadata.uid} hover_effect={tile.hover_effect}>
            {tile.image &&
              <Image
                src={`${tile.image.url}`}
                width={576}
                height={324}
              />}
            <h3>{tile.heading}</h3>
            {tile.link &&
              <Link href={tile.link.href} passHref>
                <Button href="" target="_blank">{tile.link.title}</Button>
              </Link>}
          </Item>
        })}
      </Items>

    </Wrapper>
  )
}

export default PageTiles

const Wrapper = styled(Container)`
  margin: 36px 20px;
  @media ${breakpoint.desktop} {
    margin: 72px auto;
  }
`

const Body = styled.div<any>`
  margin-bottom: 36px;
`

const Items = styled.div<any>`
`

const Item = styled.div<any>`
  margin-bottom: 72px;
  ${Button} {
    text-decoration: none;
  }
  
  ${(props) => props.hover_effect && css`
    img {
      transition: all 1s ease 0s;
      transform-origin: 100px;
      &:hover {
        transition-duration: 2.5s;
        transform: scale(1.2);
        transition-timing-function: ease-out;
      }
    }
  `}
`
